import {
    defaultMarketResearchState,
    MarketResearchState,
    RelodeApiError,
} from "@relode/core";

import {
    JobDetails,
    JobShareDetails,
    TeamMemberSuggestion,
} from "../../../shared/types";
import { ErrorType } from "./errorType";

export interface JobState {
    ui: {
        errors: {
            type: string;
            message?: string;
            apiError?: RelodeApiError;
        }[];
        error?: {
            type: ErrorType;
            message?: string;
            apiError?: RelodeApiError;
        };
        isJobLoading: boolean;
        selectedTab?: string;

        isJobCandidatesFunnelLoading: boolean;
        jobCandidatesFunnelError?: RelodeApiError;

        isJobEngagementFunnelLoading: boolean;
        jobEngagementFunnelError?: RelodeApiError;

        isJobStatsLoading: boolean;
        jobStatsError?: RelodeApiError;
    };
    data: {
        currentJobId: number;
        job: JobDetails;
        marketResearchAvailable: boolean;
        marketResearch: MarketResearchState;
        shareSuggestions: TeamMemberSuggestion[];
        shareDetails: JobShareDetails;
    };
}

export const initialJobState: JobState = {
    ui: {
        isJobLoading: false,
        error: undefined,
        errors: [],
        selectedTab: "details",
        isJobCandidatesFunnelLoading: false,
        jobCandidatesFunnelError: undefined,

        isJobEngagementFunnelLoading: false,
        jobEngagementFunnelError: undefined,

        isJobStatsLoading: false,
        jobStatsError: undefined,
    },
    data: {
        currentJobId: undefined,
        job: undefined,
        shareSuggestions: [],
        shareDetails: undefined,
        marketResearchAvailable: false,
        marketResearch: defaultMarketResearchState,
    },
};
